import React, { Component } from 'react';
import { ModalContext } from "./contexts/ModalContext";

function modalConsControl(WhatComponentNeedsModalControl) {
  const hoc = class extends Component {

    render() {
      return (
        <ModalContext.Consumer>
          {value => <WhatComponentNeedsModalControl changeModal={value} {...this.props}/>}
        </ModalContext.Consumer>
      );
    }
  };

  hoc.displayName = (WhatComponentNeedsModalControl.displayName || WhatComponentNeedsModalControl.name);
  return hoc;
}

export { modalConsControl };
